import React, { PureComponent } from 'react';
import OffersSeoWrapper from './components/index';
import OfferTypeTabs from './components/tabs/index';

export default class OffersPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: null,
      pristine: true
    };
  }

  render() {
    const {
      initial_params,
      params,
      seo_params,
      curiosities,
      region_information,
      is_from_germany
    } = this.props;
    const breadcrumbs = this.state.breadcrumbs || this.props.breadcrumbs;

    return (
      <div>
        <section className="offer-type-tabs">
          <OfferTypeTabs
            params={params}
            seo_params={seo_params}
            breadcrumbs={breadcrumbs}
          />
        </section>
        <OffersSeoWrapper
          initial_params={initial_params}
          params={params}
          seo_params={seo_params}
          curiosities={curiosities}
          region_information={region_information}
          is_from_germany={is_from_germany}
          getBreadcrumbsList={this.getBreadcrumbsList}
        />
      </div>
    );
  }

  getBreadcrumbsList = breadcrumbs => {
    if (this.state.pristine) {
      this.setState({ pristine: false });
    } else {
      this.setState({ breadcrumbs });
      const jsonBreadcrumbs = document.getElementById('json-breadcrumbs');
      if (jsonBreadcrumbs) {
        jsonBreadcrumbs.innerHTML = JSON.stringify(breadcrumbs);
      }
    }
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/index.jsx